var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { makeStyles } from '@material-ui/core';
var drawerWidth = 240;
export var useStyles = makeStyles(function (theme) {
    var _a;
    return ({
        root: {
            display: 'flex',
        },
        appBar: {
            zIndex: theme.zIndex.drawer + 1,
            transition: theme.transitions.create(['width', 'margin'], {
                easing: theme.transitions.easing.sharp,
                duration: theme.transitions.duration.leavingScreen,
            }),
            background: theme.palette.common.white,
            position: 'fixed',
            top: 0,
            left: 0,
            width: '100%',
        },
        grow: {
            flexGrow: 1,
        },
        hide: {
            display: 'none',
        },
        drawer: {
            width: drawerWidth,
            flexShrink: 0,
            whiteSpace: 'nowrap',
        },
        drawerOpen: {
            width: drawerWidth,
            transition: theme.transitions.create('width', {
                easing: theme.transitions.easing.sharp,
                duration: theme.transitions.duration.enteringScreen,
            }),
        },
        drawerClose: (_a = {
                transition: theme.transitions.create('width', {
                    easing: theme.transitions.easing.sharp,
                    duration: theme.transitions.duration.leavingScreen,
                }),
                overflowX: 'hidden',
                width: theme.spacing(7) + 1
            },
            _a[theme.breakpoints.up('sm')] = {
                width: theme.spacing(9) + 1,
            },
            _a),
        toolbar: __assign({ display: 'flex', alignItems: 'center', justifyContent: 'flex-end', padding: '0 8px' }, theme.mixins.toolbar),
        content: {
            flexGrow: 1,
            padding: theme.spacing(3),
        },
        locationSelector: {
            marginLeft: theme.spacing(2),
            flex: 1,
            justifyContent: 'flex-end',
            '&:empty': {
                display: 'none',
            },
        },
        sectionContent: {
            display: 'flex',
            alignItems: 'center',
        },
        flexContainer: {
            flex: 1,
            justifyContent: 'flex-end',
            '&:empty': {
                display: 'none',
            },
        },
        growContainer: { display: 'inline-block', flexGrow: 1 },
    });
});
//# sourceMappingURL=headerStyles.js.map